<template >
  <div v-if="value" class="element-modal element-term-popup">
    <div class="container">
      
      <div class="header">
        개인정보 수집 및 회원 약관
      </div>

      <div class="body" style="overflow:hidden;">
        <iframe src="/static/term.html" style="height: 100%; width: 100%; pointer-events: auto;"></iframe>
      </div>

      <div class="footer">
        <div class="button" @click="click(false)">
          확인
        </div>
      </div>
      
    </div>
  </div>
</template>
<script>
export default {
  props: [ "value" ],
  computed: {
    model: {
      get(){
        return this.value;
      },
      set( value ){
        this.$emit( "input", value );
      }
    }
  },
  methods: {

    click( value ){
      this.$emit( "input", false );
    }

  }

}
</script>
